import classNames from 'classnames';
import React from 'react';

export const TableHeaders = ({ headerGroup }) => {
  return (
    <>
      <div
        {...headerGroup.getHeaderGroupProps()}
        className="tr"
        key="title"
        data-top-header-row
      >
        {headerGroup.headers.map((column, i) => (
          <div key={i} {...column.getHeaderProps()} className="th">
            <span {...column.getSortByToggleProps()}>
              {column.render('Header')}{' '}
              {column.isSorted && (
                <strong>{column.isSortedDesc ? '↓' : '↑'}</strong>
              )}
            </span>
            <div
              {...column.getResizerProps()}
              className={classNames('resizer', {
                'is-resizing': column.isResizing,
              })}
            />
          </div>
        ))}
      </div>
      <div {...headerGroup.getHeaderGroupProps()} className="tr" key="filter">
        {headerGroup.headers.map((column, i) => (
          <div
            key={i}
            {...column.getHeaderProps()}
            onClick={undefined}
            className={classNames('th', 'unclickable')}
          >
            <div>{column.canFilter ? column.render('Filter') : null}</div>
            <div
              {...column.getResizerProps()}
              className={classNames('resizer', {
                'is-resizing': column.isResizing,
              })}
            />
          </div>
        ))}
      </div>
    </>
  );
};
